export const Types = {
  WIDGET: 'widget',
}
